import { render, staticRenderFns } from "./SidebarTabVersions.vue?vue&type=template&id=61dc41e0"
import script from "./SidebarTabVersions.vue?vue&type=script&lang=js"
export * from "./SidebarTabVersions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports